<template>
    <div class="modal fade" id="personSelectorModal" role="dialog" aria-labelledby="selectorPersonModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="selectorPersonModalLabel">{{$t('buttons.personSelect.btnText')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <person-selector ref="personSelector"
                                     :show="showSelector"
                                     :showId="showId"
                                     :includeMergedProfiles="includeMergedProfiles"
                                     :show-modal="showSelector"
                                     @personSelected="onPersonSelected">
                    </person-selector>

                </div>

                <div class="modal-footer m-0">
                    <div v-if="selectedPerson != null" role="group" class="btn-group" aria-label="Person selector modal">
                        <button type="button" class="btn btn-link text-success" @click.stop="onSelect"><i class="fas fa-check mr-2"></i>{{ $t('buttons.ok') }}</button>
                        <button type="button" class="btn btn-link text-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Person } from '../../models/models';
    import PersonSelector from './PersonSelector';

    export default {
        components: {
            PersonSelector
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            showId: {
                type: Boolean,
                default: false
            },
            includeMergedProfiles: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showSelector: false,
                selectedPerson: {
                    type: Person,
                    default: null
                },
            };
        },
        methods: {
            onPersonSelected(person) {
                this.selectedPerson = person;
            },
            onClose(e) {
                if (e.target.id === 'personSelectorModal') {
                    this.selectedPerson = null;
                    this.clearSelector();
                    this.$emit('onClose');
                }
            },
            hide() {
                this.showSelector = false;
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.selectedPerson = null;
                this.clearSelector();
                this.$emit('onClose');
            },
            onSelect() {
                this.$emit('onSelect', { ...this.selectedPerson });
                this.clearSelector();
                this.selectedPerson = null;
            },
            clearSelector() {
                this.$refs.personSelector.clearPerson();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal', this.onClose);
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.selectedPerson = null;
                    this.showSelector = true;
                    $(this.$el).modal('show');
                } else {
                    this.showSelector = false;
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
